var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Snackbar from '@material-ui/core/Snackbar';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Helmet } from 'react-helmet';
import { Map } from 'immutable';
// - Import components
import MasterLoading from 'src/components/masterLoading';
import SendFeedback from 'src/components/sendFeedback';
import MasterRouter from 'src/routes/MasterRouter';
import { ServiceProvide } from 'src/core/factories';
import '../../containers/login/myshit.scss';
// - Import actions
import { authorizeActions, imageGalleryActions, postActions, commentActions, voteActions, userActions, globalActions, circleActions, notifyActions } from 'src/store/actions';
/* ------------------------------------ */
// - Create Master component class
var MasterComponent = /** @class */ (function (_super) {
    __extends(MasterComponent, _super);
    // Constructor
    function MasterComponent(props) {
        var _this = _super.call(this, props) || this;
        // Handle click on message
        _this.handleMessage = function (evt) {
            _this.props.closeMessage();
        };
        _this._serviceProvider = new ServiceProvide();
        _this._authourizeService = _this._serviceProvider.createAuthorizeService();
        _this.state = {
            loading: true,
            authed: false,
            dataLoaded: false,
            isVerifide: false
        };
        // Binding functions to `this`
        _this.handleMessage = _this.handleMessage.bind(_this);
        return _this;
    }
    MasterComponent.prototype.componentDidCatch = function (error, info) {
    };
    MasterComponent.prototype.componentDidMount = function () {
        var _this = this;
        this._authourizeService.onAuthStateChanged(function (isVerifide, user) {
            var _a = _this.props, global = _a.global, clearData = _a.clearData, loadDataGuest = _a.loadDataGuest, defaultDataDisable = _a.defaultDataDisable, defaultDataEnable = _a.defaultDataEnable, login = _a.login, logout = _a.logout, showMasterLoading = _a.showMasterLoading, hideMasterLoading = _a.hideMasterLoading;
            if (user) {
                login(user.uid, isVerifide);
                hideMasterLoading();
                _this.setState({
                    loading: false,
                    isVerifide: true
                });
            }
            else {
                logout();
                hideMasterLoading();
                _this.setState({
                    loading: false,
                    isVerifide: false
                });
                if (global.defaultLoadDataStatus) {
                    defaultDataDisable();
                    clearData();
                }
                loadDataGuest();
            }
        });
    };
    /**
     * Render app DOM component
     *
     * @returns
     *
     * @memberof Master
     */
    MasterComponent.prototype.render = function () {
        var _a = this.props, progress = _a.progress, global = _a.global, loaded = _a.loaded, guest = _a.guest, uid = _a.uid, sendFeedbackStatus = _a.sendFeedbackStatus, hideMessage = _a.hideMessage;
        var _b = this.state, loading = _b.loading, isVerifide = _b.isVerifide;
        return (React.createElement("div", { id: 'master' },
            React.createElement(Helmet, null,
                React.createElement("meta", { charSet: 'utf-8' }),
                React.createElement("meta", { name: 'description', content: 'Hullthread, a new era in fashion. A fashion platform that gives Artists free range of creation using 3d models.' }),
                React.createElement("title", null, "Hullthread - A New Era of Fashion"),
                React.createElement("link", { rel: 'canonical', href: 'https://hullthread.com' })),
            sendFeedbackStatus ? React.createElement(SendFeedback, null) : '',
            React.createElement("div", { className: 'master__progress', style: { display: (progress.visible ? 'block' : 'none') } },
                React.createElement(LinearProgress, { variant: 'determinate', value: progress.percent })),
            React.createElement("div", { className: 'master__loading animate-fading2', style: { display: (global.showTopLoading ? 'flex' : 'none') } },
                React.createElement("div", { className: 'title' }, "Loading ... ")),
            progress.visible ? React.createElement(MasterLoading, null) : '',
            React.createElement(MasterRouter, { enabled: !loading, data: { uid: uid } }),
            React.createElement(Snackbar, { open: this.props.global.messageOpen, message: this.props.global.message, onClose: hideMessage, autoHideDuration: 4000, style: { left: '1%', transform: 'none' } })));
    };
    MasterComponent.isPrivate = true;
    return MasterComponent;
}(Component));
export { MasterComponent };
// - Map dispatch to props
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        clearData: function () {
            dispatch(imageGalleryActions.clearAllData());
            dispatch(postActions.clearAllData());
            dispatch(userActions.clearAllData());
            dispatch(commentActions.clearAllData());
            dispatch(voteActions.clearAllvotes());
            dispatch(notifyActions.clearAllNotifications());
            dispatch(circleActions.clearAllCircles());
            dispatch(globalActions.clearTemp());
        },
        login: function (userId, isVerifide) {
            dispatch(authorizeActions.login(userId, isVerifide));
        },
        logout: function () {
            dispatch(authorizeActions.logout());
        },
        defaultDataDisable: function () {
            dispatch(globalActions.defaultDataDisable());
        },
        defaultDataEnable: function () {
            dispatch(globalActions.defaultDataEnable());
        },
        closeMessage: function () {
            dispatch(globalActions.hideMessage());
        },
        loadDataGuest: function () {
            dispatch(globalActions.loadDataGuest());
        },
        showMasterLoading: function () { return dispatch(globalActions.showMasterLoading()); },
        hideMasterLoading: function () { return dispatch(globalActions.hideMasterLoading()); },
        hideMessage: function () { return dispatch(globalActions.hideMessage()); }
    };
};
/**
 * Map state to props
 * @param {object} state
 */
var mapStateToProps = function (state) {
    var authorize = Map(state.get('authorize', {})).toJS();
    var global = Map(state.get('global', {})).toJS();
    var sendFeedbackStatus = global.sendFeedbackStatus, progress = global.progress;
    return {
        sendFeedbackStatus: sendFeedbackStatus,
        progress: progress,
        guest: authorize.guest,
        uid: authorize.uid,
        authed: authorize.authed,
        global: global
    };
};
// - Connect commponent to redux store
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MasterComponent));



//////////////////
// WEBPACK FOOTER
// ./src/containers/master/MasterComponent.tsx
// module id = 664
// module chunks = 50